import { Injectable } from '@angular/core';
import { GrowlManager } from './growl.manager';

@Injectable()
export class ValidatorManager {

    constructor (private growlManager: GrowlManager) {}

    isLowerThan(value: number,
                limit: number,
                showGrowl: boolean,
                growlExplanationString: string,
                growlExplanationNumberFollow: boolean) {
        
        if (value === undefined || value === null) {
            value = 0;
        }
        
        if (value < limit) {
            value = limit;
            
            if (showGrowl === true) {
                let outString = growlExplanationString;
                if (growlExplanationNumberFollow === true) { outString = outString + value.toString(); }
                this.growlManager.showWarning(outString.toString());
            }
            
            return value;
        }
        return value;
    }
    
    isHigherThan(value: number,
                limit: number,
                showGrowl: boolean,
                growlExplanationString: string,
                growlExplanationNumberFollow: boolean) {
        
        if (value === undefined || value === null) {
            value = 0;
        }
        
        if (value > limit) {
            value = limit;
            
            if (showGrowl === true) {
                let outString = growlExplanationString;
                if (growlExplanationNumberFollow === true) { outString = outString + value.toString(); }
                this.growlManager.showWarning(outString.toString());
            }
            
            return value;
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/manager/validator.manager.ts